/**
 * SEO Configuration - Unique titles and meta descriptions for all pages
 * Language: Norwegian (Bokmål)
 * Sauna model titles/descriptions use live marketing copy + dimensions + base price
 * from SaunaPrice (the same source that renders "Fra: X NOK" on each subpage).
 */

export const seoConfig = {
  '/': {
    title: 'Skreddersydde badstuer i nordisk arkitektur | LYKKE NOMAD',
    description: 'LYKKE NOMAD designer og bygger eksklusive badstuer tilpasset norsk natur. Se vårt utvalg og kontakt oss i dag.',
    keywords: 'Badstue, Badstue utendørs, badstue byggesett, badstue hjemme, badstue i hagen, badstue oslo, badstue pris, badstue ute, ferdig badstue, vedfyrt badstue',
  },
  '/om-oss': {
    title: 'Om oss – LYKKE NOMAD',
    description: 'LYKKE NOMAD er et norsk selskap som designer skreddersydde badstuer med fokus på nordisk arkitektur.',
  },
  '/process': {
    title: 'Slik fungerer prosessen | LYKKE NOMAD',
    description: 'Fra idé til ferdig badstue – se hvordan vi guider deg gjennom hele prosessen.',
  },
  '/konfigurator': {
    title: 'Konfigurer din badstue | LYKKE NOMAD',
    description: 'Design din egen skreddersydde badstue med vår konfigurator. Velg blant våre modeller og tilpass til dine ønsker.',
  },
  '/be-om-tilbud': {
    title: 'Kontakt oss – LYKKE NOMAD',
    description: 'Ta kontakt med LYKKE NOMAD for en uforpliktende samtale om din nye badstue. Vi svarer vanligvis innen 24 timer.',
  },
  '/sauna-ly': {
    title: 'LYKKE LY-serien – Kompakte badstuer | LYKKE NOMAD',
    description: 'LYKKE LY-serien tilbyr kompakte og elegante badstuer. Se Umi, Mori, Hiro, Yori og Tori.',
  },
  '/sauna-panorama': {
    title: 'LYKKE PANORAMA-serien – Badstuer med utsikt | LYKKE NOMAD',
    description: 'LYKKE PANORAMA-serien er designet med store glassflater for maksimal utsikt. Se Cortina, Dolomiti, Vikka, Chamonix, Trysil og Geilo.',
  },
  '/sauna-fjel': {
    title: 'LYKKE FJELL-serien – Badstuer for fjellet | LYKKE NOMAD',
    description: 'LYKKE FJELL-serien kombinerer robust design med funksjonalitet. Se Verbier, Hytte og Aspen.',
  },
  '/sauna-umi': {
    title: 'LYKKE UMI – Badstue for 3–4 personer | LYKKE NOMAD',
    description: 'Liten og elegant badstue, perfekt når plassen er begrenset. 255×271×330 cm, 3–4 personer. Fra 245 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-mori': {
    title: 'LYKKE MORI – Klassisk badstue for 4–6 personer | LYKKE NOMAD',
    description: 'MORI er klassisk, rolig og tidløs, med særegne proporsjoner. 359×255×330 cm, 4–6 personer. Fra 310 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-hiro': {
    title: 'LYKKE HIRO – Badstue med forstue | LYKKE NOMAD',
    description: 'Med innelukket forstue blir badstuen en hel opplevelse, varmt og klart fra kulden. 619×255×330 cm. Fra 485 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-yori': {
    title: 'LYKKE YORI – Badstue med fokus på detaljer | LYKKE NOMAD',
    description: 'YORI tenker på detaljer, fra du går inn til du kommer ut igjen. 727×255×330 cm, 4–6 personer. Fra 515 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-tori': {
    title: 'LYKKE TORI – Stor badstue for 8–12 personer | LYKKE NOMAD',
    description: 'For dem som ikke gjør halvveis – design, kvalitet og rommelighet i ett. 1013×255×330 cm, 8–12 personer. Fra 595 000 NOK.',
  },
  '/sauna-trysil': {
    title: 'LYKKE TRYSIL – Badstue med utsikt | LYKKE NOMAD',
    description: 'Sitt varmt inni mens utsikten gjør resten – en kombinasjon som bare fungerer. 440×240 cm, 6–8 personer. Fra 315 000 NOK.',
  },
  '/sauna-cortina': {
    title: 'LYKKE CORTINA – Badstue med store glassflater | LYKKE NOMAD',
    description: 'Store glassflater åpner badstuen helt mot utsikten – nyt hvert øyeblikk. 220×220 cm, 4–6 personer. Fra 179 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-dolomiti': {
    title: 'LYKKE DOLOMITI – Minimalistisk badstue | LYKKE NOMAD',
    description: 'Glasering gjør naturen til en del av opplevelsen – minimalistisk med stor innvirkning. 240×220 cm, 6–8 personer. Fra 205 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-vikka': {
    title: 'LYKKE VIKKA – Lys og åpen badstue | LYKKE NOMAD',
    description: 'Lys og åpen badstue som lar deg være nær naturen, uten noe ekstra. 340×240 cm, 4–6 personer. Fra 260 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-chamonix': {
    title: 'LYKKE CHAMONIX – Enkel og funksjonell badstue | LYKKE NOMAD',
    description: 'Enkelt, rent og funksjonelt – skjønnhet i det som ikke er unødvendig komplisert. 400×240 cm, 4–6 personer. Fra 275 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-geilo': {
    title: 'LYKKE GEILO – Badstue uten kompromisser | LYKKE NOMAD',
    description: 'Når alt skal stemme helt – ingen kompromisser på arkitektur eller utsikt. 350×230 cm, 6–8 personer. Fra 275 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-verbier': {
    title: 'LYKKE VERBIER – Kompakt badstue med karakter | LYKKE NOMAD',
    description: 'Kompakt badstue med karakteristisk form og tydelig arkitektonisk uttrykk. 340×310 cm, 4–6 personer. Fra 198 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-hytte': {
    title: 'LYKKE HYTTE – Badstue i nordisk hyttestil | LYKKE NOMAD',
    description: 'Inspirert av klassiske nordiske hytter, utviklet for tradisjonelle hytteområder. 370×310 cm, 4–6 personer. Fra 185 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-aspen': {
    title: 'LYKKE ASPEN – Badstue med utvendig dusj | LYKKE NOMAD',
    description: 'Større modell med integrert utvendig dusj og terrasse for avkjøling. 420×310 cm, 6–8 personer. Fra 235 000 NOK. LYKKE NOMAD.',
  },
  '/sauna-nomad': {
    title: 'LYKKE NOMAD badstue – den mobile badstuen | LYKKE NOMAD',
    description: 'LYKKE NOMAD er den originale mobile badstuen – enkel, elegant og praktisk. Ta badstuen med deg til hytta, hagen eller fjellet.',
  },
  '/tiny-bnb-17m': {
    title: 'TinyBnB 17 m² – Kompakt minihus | LYKKE NOMAD',
    description: 'TinyBnB: kompakt minihus på 17 m² med badstue. Perfekt for gjestetilbud eller å leie ut. Bærekraftig og moderne design.',
  },
  '/laer-mer-handverk': {
    title: 'Lær mer om håndverket – Materialer og prosess | LYKKE NOMAD',
    description: 'Utdypet guide til materialene vi bruker: Kebony kledning, termo-asp, HUUM ovner og mer. Forstå kvaliteten bak hver badstue.',
  },
  '/sertifikater': {
    title: 'Sertifikater og standarder – Kvalitetssikring | LYKKE NOMAD',
    description: 'Vi oppfyller høyeste norske og internasjonale standarder. StartBANK sertifikat, HMS system, kvalitetssikring. Ditt valg av sikker leverandør.',
  },
  '/portfolio': {
    title: 'Portfolio – Inspirasjon fra realiserte prosjekter | LYKKE NOMAD',
    description: 'Se våre realiserte badstueprosjekter fra hele Norge. Foto fra installasjon, omgivelser og detaljer. Inspirasjon for ditt prosjekt.',
  },
  '/kebony-vedlikehold': {
    title: 'Kebony vedlikehold – Pleie av din badstue | LYKKE NOMAD',
    description: 'Vedlikeholdsveiledning for Kebony-behandlet tre. Enkle tips for å holde din badstue vakker i mange år.',
  },
  '/handverket': {
    title: 'Håndverket – Nordisk tradisjon møter modernitet | LYKKE NOMAD',
    description: 'Oppdag håndverket bak hver LYKKE badstue. Tradisjonelle teknikker kombinert med moderne kvalitetskontroll.',
  },
  '/eksteriormaling': {
    title: 'Eksterior maling – Velge riktig farge og finish | LYKKE NOMAD',
    description: 'Guide til eksterior maling for badstuer. Fargevalg, vedlikehold og tips for å bevare skjønnheten.',
  },
  '/privacy-policy': {
    title: 'Personvernpolicy – LYKKE NOMAD',
    description: 'Lese vår personvernpolicy og lær hvordan vi håndterer dine data.',
  },
  '/cookie-policy': {
    title: 'Informasjonskapsler – LYKKE NOMAD',
    description: 'Lese vår informasjonskapsel policy. Vi bruker cookies for å forbedre ditt besøk.',
  },
  '/terms-of-service': {
    title: 'Vilkår for bruk – LYKKE NOMAD',
    description: 'Les vilkårene for bruk av lykke.info nettsiden.',
  },
};

/**
 * Hero image per route — used by App.jsx to keep a per-route
 * <link rel="preload" as="image"> in sync with the actual LCP image
 * of the current page (instead of one global default for all routes).
 */
export const seoHeroImages = {
  '/': 'https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/362e32b97_Verbier_vinter3.jpg',
  '/sauna-ly': 'https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/ac944b326_LYKKE_UMI_DETALMORI1.png',
  '/sauna-panorama': 'https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/f4f8b636c_Panorama_Detal.jpg',
  '/sauna-fjel': 'https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/7004d600a_Verbier_1.jpg',
  '/sauna-umi': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/e4bcd05c1_Umi-main.png',
  '/sauna-mori': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/79d22a547_Mori-main.png',
  '/sauna-hiro': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/64064a012_MainpicHiro.png',
  '/sauna-yori': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/18ac775f3_ChatGPTImage12maj202612_24_14.png',
  '/sauna-tori': 'https://media.base44.com/images/public/69a726345560d5ef49a37111/75d0922d0_LYKKETORI1.jpg',
  '/sauna-verbier': 'https://media.base44.com/images/public/69a726345560d5ef49a37111/4df33f500_SAUNAVEIBER_2.jpg',
  '/sauna-cortina': 'https://media.base44.com/images/public/69a726345560d5ef49a37111/5f9a650a8_CortinaWhite.jpg',
  '/sauna-dolomiti': 'https://media.base44.com/images/public/69a726345560d5ef49a37111/c109e0135_Dolomiti_Thermo2.jpg',
  '/sauna-vikka': 'https://media.base44.com/images/public/69a726345560d5ef49a37111/865e7e4f7_sauna_vikka.jpg',
  '/sauna-chamonix': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/af19145b9_Chamo7.jpg',
  '/sauna-trysil': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/cc23ae1b9_LYKKETRYSIL_long_1.jpg',
  '/sauna-geilo': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/89b3cff02_LYKKEGEILO.jpg',
  '/sauna-aspen': 'https://media.base44.com/images/public/69dc8b74fce3eacbe6523c04/9361a98b8_Aspen3.jpg',
  '/sauna-hytte': 'https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/b97e9bc00_strefa_rekreacyjna_4k_v7.jpg',
  '/sauna-nomad': 'https://myodoo-pl-lykke.odoo.com/web/image/16838-946abc4b/nano%20mobile.jpeg?access_token=af9ee5ae-d560-4062-942f-d860a7634e00',
};

export function getSeoConfig(pathname) {
  return seoConfig[pathname] || {
    title: 'LYKKE NOMAD – Premium badstuer | Nordisk arkitektur, Oslo',
    description: 'Vi designer og bygger premium badstuer med nordisk arkitektur. Skreddersydde utendørsbadstuer levert over hele Norge.',
  };
}